export default "__VITE_ASSET__fuc8b_8R__"